import React from 'react';
const IconFormToggle = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M9 8H15C17.2091 8 19 9.79086 19 12C19 14.2091 17.2091 16 15 16H9C6.79086 16 5 14.2091 5 12C5 9.79086 6.79086 8 9 8ZM3 12C3 8.68629 5.68629 6 9 6H15C18.3137 6 21 8.68629 21 12C21 15.3137 18.3137 18 15 18H9C5.68629 18 3 15.3137 3 12ZM18 12C18 13.6569 16.6569 15 15 15C13.3431 15 12 13.6569 12 12C12 10.3431 13.3431 9 15 9C16.6569 9 18 10.3431 18 12Z" fill="#2D2E2E"/>
</svg>);
};
export default IconFormToggle;